export default __webpack_public_path__ + "static/media/processing_report.3d356c9d.pdf";